<template>
    <div>
        <p v-text="submittal.name"></p>
        <h4><a href="#" @click.prevent @click="openNote1">View Notes</a></h4>
        <div class="remodal" data-remodal-id="1">
            <header class="tertiary">
                <h2>Notes for {{ submittal.name }}</h2>
            </header>

            <button data-remodal-action="close" class="remodal-close simple"></button>

            <p v-if="submittal.notes1.length == 0 && submittal.notes2.length == 0">
                There are no notes for this submittal.</p>

            <label v-if="submittal.notes1.length > 0">
                Notes 1
                <textarea name="" cols="30" rows="10" v-text="submittal.notes1" disabled></textarea>
            </label>

            <label v-if="submittal.notes2.length > 0">
                Notes 2
                <textarea name="" cols="30" rows="10" v-text="submittal.notes2" disabled></textarea>
            </label>
            <button data-remodal-action="confirm">OK</button>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                note1: {},
                note2: {}
            };
        },
        methods: {
            openNote1() {
                this.note1.open();
            },
            openNote2() {
                this.note2.open();
            }
        },
        mounted() {
            this.note1 = $('[data-remodal-id="1"]').remodal();
        },
        computed: {
            noNotes() {
                return this.submittal.notes1.length < 1 && this.submittal.notes2.length < 1;
            }
        },
        props: ['submittal']
    }
</script>
